// extracted by extract-css-chunks-webpack-plugin
module.exports = {"leftColumn":"YyDLZ3","dividerClass":"PdkmeV","authorContent":"_2jgPrQ","flexDirection":"_1pLuPs","renderToolTip":"_1FXKGp"};